// extracted by mini-css-extract-plugin
export default {"suggestions":"wSbrkEKB","bottom":"YGdWEJ33","top":"jKY8_1nT","suggestion":"MtG_CWxm","active":"kdLCV21p"};